import {
    ActionPointInfo,
    IActionPointInfo,
    IMiddleware,
    IStopAction,
    Middleware,
    StopAction,
    UIConfig,
    WorkbenchUIConfig,
    StateManager,
} from '@tencent/workbench';
import { SLIDE_ADAPTER } from '../editor-adpater/mobile-adapter';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { TOUCH_SLIDE_INDEX } from '@framework/workbench/const/mobile-setting-const';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { EDIT_TYPE } from '@src/slide/domain/selection/constant/edit-type';
import { IMobileEditorAppServices } from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { isUiModelIsAttachment } from '@src/slide/domain/ui-model/elements/element-judge';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';

@Middleware({
    adapters: [SLIDE_ADAPTER],
})
export class MobileContextMenuHideMiddleware implements IMiddleware {
    public constructor(
        private baseMobileContextMenuFeature: BaseMobileContextMenuFeature,
        private readonly stateManager: StateManager,
    ) {}

    // eslint-disable-next-line complexity
    public use(
    @ActionPointInfo() info: IActionPointInfo,
        @StopAction() stop: IStopAction,
        @UIConfig() config: WorkbenchUIConfig,
    ) {
        const isPreviewMode = !this.getAppServices().viewableServiceLayer.entryStateService.checkIfEditMode?.();
        if (isPreviewMode) {
            return !config.isMobilePreviewBtn as boolean;
        }
        const { lastMouseDownRegion } = this.getAppServices().viewableServiceLayer.selectionService;
        if (config?.showRegions && !config?.showRegions?.includes(lastMouseDownRegion)) {
            return true;
        }
        const { isEditingBtn, isViewBtn } = config;
        const model = this.getAppServices().viewableServiceLayer.selectionService.selectedElements.getCurrentModel();
        switch (lastMouseDownRegion) {
            case RegionType.EDITOR: {
                // 开关，非canvas下，编辑态不显示菜单
                if (model.type === UIModelType.EMPTY) { // 未选中元素， 只显示粘贴
                    return info.name !== ActionType.PASTE && info.name !== ActionType.AI_GENERATE_PAGE_MOBILE;
                }
                if (isUiModelIsAttachment(model)) {
                    // 附件元素只显示附件相关的选项
                    return info.name !== ActionType.DELETE_ATTACHMENT
                        && info.name !== ActionType.DOWNLOAD_ATTACHMENT
                        && info.name !== ActionType.SWITCH_ATTACHMENT_SHOWTYPE
                        && info.name !== ActionType.VIEW_ATTACHMENT;
                }
                if (this.getAppServices().viewableServiceLayer.editorInstanceService.checkEditorIsEditing()) {
                    return !isEditingBtn;
                }
                return !isViewBtn;
            }
            case RegionType.NOTE: {
                // 开关，非canvas下，编辑态不显示菜单
                if (this.getAppServices().viewableServiceLayer.editorInstanceService.checkEditorIsEditing()) {
                    return !isEditingBtn;
                }
                return true;
            }
            case RegionType.SLIDELIST: {
                return !this.checkSlideListMenu(info);
            }
            default:
                return true;
        }
    }

    private checkEditorMenu(model, info) {
        if (model.type === UIModelType.EMPTY) { // 未选中元素， 只显示粘贴
            return info.name === ActionType.PASTE;
        }
        if (model.isAttachment() || model.isMedia?.()) { // 附件、音视频元素， 只显示删除
            return info.name === ActionType.DELETE;
        }
        return true;
    }

    private checkSlideListMenu(info) {
        // 如果当前幻灯片页被他人锁定，则变为只读菜单, 只展示复制
        const index = this.stateManager.getValue(TOUCH_SLIDE_INDEX) || 0;
        const lockInfo = OnlineEditServices.CooperationLockManager()?.getLockInfoByIndex(index, UIModelType.SLIDE);
        if (lockInfo && !lockInfo.user?.isSelf) {
            return info.name === ActionType.COPY;
        }
        return true;
    }

    private getAppServices(): IMobileEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IMobileEditorAppServices;
    }
}
